import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMN_SPACING,
  CARDS_GRID_ITEM_SIZE,
} from '@app/components/base/content-structure/cards-grid-config';
import { EditCardSkeleton } from '../edit-card/EditCardSkeleton';

export interface VideoEditionsEditGridSkeletonProps {
  /** Number of placeholder cards (defaults to a responsive grid-friendly count). */
  count?: number;
}

/**
 * Responsive grid of {@link EditCardSkeleton} items, matching {@link VideoEditionsEditGrid} spacing.
 */
export function VideoEditionsEditGridSkeleton({ count = 6 }: VideoEditionsEditGridSkeletonProps) {
  return (
    <CardsGrid columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {Array.from({ length: count }, (_, index) => (
        <CardsGridItem size={CARDS_GRID_ITEM_SIZE} key={index}>
          <EditCardSkeleton />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
